import { myAccountWishlistTemplateURL, signInURL } from '../../configuration/Configuration.js';
import {
  renderWishlistDialogChoices,
  renderWishlistPopinConfirmation,
  renderWishlistPopinItems,
  renderWishlistPopinNotLogged,
  wishlistPopinTemplate,
} from './templates.js';
import WishlistDialog from './WishlistDialog.js';
import componentRegistry from '../registry.js';
import parseHTML from '../../helpers/dom/parseHTMLFragment.js';

export default class extends WishlistDialog {
  constructor({ el } = {}) {
    super({
      el: el ?? parseHTML(wishlistPopinTemplate).firstElementChild,
      renderChoices: (data) => renderWishlistDialogChoices(data),
      renderUnauthenticated: () => renderWishlistPopinNotLogged(signInURL()),
      renderComplete: () => renderWishlistPopinConfirmation(myAccountWishlistTemplateURL()),
      renderItems: (data) => renderWishlistPopinItems(data),
    });

    this.el.querySelector('.js-addtoWishlist-close')?.addEventListener('click', this.#handleClickEvent.bind(this));
  }

  #handleClickEvent() {
    this.close();
  }

  showModal() {
    if (!this.open) {
      this.el.classList.add('f-wishlist-dialog--open');
    }

    super.showModal({
      items: {
        src: this.el,
      },
      fixedContentPos: true,
      mainClass: `mfp--modal ${IS_MOBILE ? ' mfp--mobile' : ''}`,
      callbacks: {
        close: () => {
          this.close();
        },
      },
    });
  }

  close() {
    if (!this.open) {
      return;
    }

    this.el.classList.remove('f-wishlist-dialog--open');

    this.magnificPopup.close();
    super.close();
  }
}

componentRegistry.define('js-wishlistDialog', WishlistDialog);
